if (!customElements.get('quick-add-modal')) {
	customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
		constructor() {
			super();
			this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
		}

		hide(preventFocus = false) {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
			this.modalContent.innerHTML = '';

			$('.js-media-list').each(function () {
				this.swiper.destroy();
			});
			$('.js-media-sublist').each(function () {
				this.swiper.destroy();
			});

			subSliderInit(true);
			sliderInit(true);

			if (preventFocus) this.openedBy = null;
			super.hide();
		}

		show(opener) {
			opener.setAttribute('aria-disabled', true);
			opener.classList.add('loading');

			if (opener.querySelector('.loading-overlay__spinner')) {
				opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
			}

			fetch(opener.getAttribute('data-product-url'))
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					this.productElement = responseHTML.querySelector('section[id^="MainProduct"]');

					const specificationRows = this.productElement.querySelectorAll('#specifications tr');
					specificationRows.forEach((row) => {
						row.classList.remove('bg-white');
						row.classList.add('bg-slate-100');
					});


					this.preventDuplicatedIDs();
					this.removeDOMElements();
					this.setInnerHTML(this.modalContent, this.productElement.innerHTML, opener);

					const connectToBuy = this.modalContent.querySelectorAll('.button--connect-to-buy');
					connectToBuy.forEach(function (button) {
						console.log(button);
						button.addEventListener('click', function () {
							const modal = button.closest('.quick-add-modal');
							console.log(modal);
							if (modal) {
								// Si le modal est ouvert, le fermer (enlever l'attribut 'open')
								if (modal.hasAttribute('open')) {
									modal.removeAttribute('open');

									// Forcer la mise à jour de l'affichage pour garantir la fermeture immédiate
									requestAnimationFrame(() => {
										modal.removeAttribute('open');
									});

									console.log('Modal fermé');
								}
							}

							const header = document.querySelector('.header__account');

							const detailsElement = header.querySelector('details');

							const url = button.getAttribute('data-handle');

							console.log(url);
							// Vérifier si l'élément <details> existe
							if (detailsElement) {
								window.scrollTo({
									top: 0, // Défilement vers le tout début de la page
									behavior: 'smooth', // Activation du défilement fluide
								});

								// Si l'élément est déjà ouvert, ne rien faire
								if (!detailsElement.hasAttribute('open')) {
									// Ajouter l'attribut 'open' pour ouvrir l'élément
									detailsElement.setAttribute('open', '');

									// Pour forcer la mise à jour de l'affichage de l'attribut dans l'inspecteur, on peut utiliser requestAnimationFrame.
									// Cela peut être nécessaire si vous avez des animations ou un comportement asynchrone qui empêche la mise à jour immédiate.
									requestAnimationFrame(() => {
										detailsElement.setAttribute('open', '');
									});
								}

								// Récupérer l'élément du formulaire à l'intérieur du <details>
								const loginForm = detailsElement.querySelector('form#customer_login');

								// Si le formulaire existe, injecter le champ return_url
								if (loginForm) {
									// Créer un nouvel input caché pour return_url
									const returnUrlInput = document.createElement('input');
									returnUrlInput.type = 'hidden';
									returnUrlInput.name = 'return_url';
									returnUrlInput.value = url; // URL actuelle de la page (ou utilisez current_url en Liquid)

									// Ajouter le champ caché au formulaire
									loginForm.appendChild(returnUrlInput);
								}
							}
						});
					});
					if (window.Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}

					if (window.ProductModel) window.ProductModel.loadShopifyXR();

					this.removeGalleryListSemantic();
					this.updateImageSizes();
					this.preventVariantURLSwitching();
					super.show(opener);

				})
				.finally(() => {

					opener.removeAttribute('aria-disabled');
					opener.classList.remove('loading');

					if (opener.querySelector('.loading-overlay__spinner')) {
						opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
					}

					subSliderInit();
					sliderInit();

					/* Toggle fields */
					$('.js-show-more').click(function (e) {
						e.preventDefault();
						$(this).siblings('input').removeClass('hidden');
						$(this).siblings('label').removeClass('hidden');
						$(this).remove();
					});

					const productId = this.productElement.id;
					let view = null;

					if (productId.includes('CartridgeCompatibles')) {
						view = 'cartridge-compatibles';
					} else if (productId.includes('PrinterCompatibles')) {
						view = 'printer-compatibles';
					}

					if (view) {
						const productHandle = this.productElement.getAttribute('data-product-handle');

						console.log(view, productHandle)
						// Émettre un événement personnalisé
						this.init(productHandle, view); // Appel à la fonction d'initialisation

					}


				});
		}

		setInnerHTML(element, html, opener) {
			element.innerHTML = html;

			// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
			element.querySelectorAll('script').forEach(oldScriptTag => {
				const newScriptTag = document.createElement('script');
				Array.from(oldScriptTag.attributes).forEach(attribute => {
					newScriptTag.setAttribute(attribute.name, attribute.value)
				});
				newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
			});

			// Read more button
			const moreBtn = document.createElement('a');
			moreBtn.textContent = `${theme.quickviewMore}`;
			moreBtn.setAttribute('href', opener.getAttribute('data-product-url'));
			moreBtn.setAttribute('class', 'product__full-details');
			element.querySelector('.product__info-container').appendChild(moreBtn);
		}

		removeDOMElements() {
			const relatedSlider = this.productElement.querySelectorAll('related-slider');
			if (relatedSlider) relatedSlider.forEach(el => { el.remove(); });

			const promoBanner = this.productElement.querySelectorAll('.promo-banner');
			if (promoBanner) promoBanner.forEach(el => { el.remove(); });

			const reviews = this.productElement.querySelector('[data-block-handle="reviews"]');
			if (reviews) reviews.remove();

			const about = this.productElement.querySelector('.about');
			if (about) about.remove();

			const text = this.productElement.querySelector('.product__text');
			if (text) text.remove();

			const shareButtons = this.productElement.querySelector('.share-buttons');
			if (shareButtons) shareButtons.remove();

			const rating = this.productElement.querySelector('.product__info-container .rating');
			if (rating) rating.remove();

			const productReviews = this.productElement.querySelector(
				"#shopify-product-reviews",
			);
			if (productReviews) productReviews.remove();

			const tags = this.productElement.querySelector('.product-tags');
			if (tags) tags.remove();

			const description = this.productElement.querySelector('.product__description');
			if (description) description.remove();

			const advantages = this.productElement.querySelectorAll('.advantage-text');
			advantages.forEach(advantage => {
				advantage.remove();
			});

			const note = this.productElement.querySelector('.note');
			if (note) note.remove();

			const pickupAvailability = this.productElement.querySelector('pickup-availability');
			if (pickupAvailability) pickupAvailability.remove();

			const productModal = this.productElement.querySelector('product-modal');
			if (productModal) productModal.remove();

			const productForm = this.productElement.querySelector('floated-form');
			if (productForm) productForm.remove();

			const gift = this.productElement.querySelector('.customer');
			if (gift) gift.remove();
		}

		preventDuplicatedIDs() {
			console.log(this.productElement)
			const sectionId = this.productElement.dataset.section;
			this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
			this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
				variantSelect.dataset.originalSection = sectionId;
			});
		}

		preventVariantURLSwitching() {
			if (this.modalContent.querySelector('variant-radios,variant-selects')) {
				this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
			}
		}

		removeGalleryListSemantic() {
			const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
			if (!galleryList) return;

			galleryList.setAttribute('role', 'presentation');
			galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
		}

		updateImageSizes() {
			const product = this.modalContent.querySelector('.product');
			const desktopColumns = product.classList.contains('product--columns');
			if (!desktopColumns) return;

			const mediaImages = product.querySelectorAll('.product__media img');
			if (!mediaImages.length) return;

			let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

			if (product.classList.contains('product--medium')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '605px');
			} else if (product.classList.contains('product--small')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '495px');
			}

			mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
		}

		async init(productHandle, view) {
			try {
				const product = await this.fetchProductData(productHandle);
				await this.renderProduct(product, view);
			} catch (error) {
				console.error('Error initializing product data:', error);
			}
		}

		extractModelTags(tags) {
			if (!tags) return [];
			return tags
				.split(/,\s*/)
				.map(tag => tag.trim())
				.filter(tag => tag.startsWith('model_'));
		}

		async renderProduct(compatible, view) {
			if (!compatible) {
				console.error("No compatible product provided.");
				return;
			}
			const models = this.extractModelTags(compatible.tags);
			if (!models || models.length === 0) {
				console.warn("No models found in product tags.");
				return;
			}
			const container = document.querySelector('#printer-products-container');
			if (!container) {
				console.error("Container for printer products not found.");
				return;
			}
			try {
				const fetchPromises = models.map(async (model) => {
					const url = `/search?q=${model}&type=product&unavailable_products=show&sort_by=price-ascending&view=${view}`;
					const response = await fetch(url);
					if (!response.ok) {
						console.error(`Failed to fetch data for model ${model}:`, response.statusText);
						return null;
					}
					const html = await response.text();
					return html.split("<!-- resultat -->")[1] || '';
				});
				const results = await Promise.all(fetchPromises);
				const validResults = results.filter(result => result);
				if (validResults.length > 0) {
					container.insertAdjacentHTML('beforeend', validResults.join(''));
					const compatibleHeader = container.querySelector('.compatible-header');
					const compatibleProductsEl = container.querySelector('.sorted-products-container');
					if (compatibleHeader && compatibleProductsEl) {
						if (compatible.product_type?.toLowerCase() === 'printer' && compatible.variants[0]?.price !== "0.00") {
							compatibleHeader.classList.add('hidden');
							compatibleProductsEl.classList.remove('col-span-3');
							compatibleProductsEl.classList.add('col-span-4');
						} else {
							this.initializeFilters(container, compatibleProductsEl);
						}
						this.groupAndSort(compatibleProductsEl);
					} else {
						console.warn("No sorted products container found after injecting all HTML.");
					}
				} else {
					console.warn("No valid results to inject into the container.");
				}
			} catch (error) {
				console.error("Error fetching or processing models:", error);
			}
		}

		initializeFilters(container, productsContainer) {
			const filterContainer = container.querySelector('.compatible-header .filters-container');
			if (!filterContainer) {
				console.error("Filter container not found.");
				return;
			}
			const productElements = productsContainer.querySelectorAll('.favorite-product');
			const states = new Set();
			const colors = new Set();
			productElements.forEach(product => {
				const classes = product.classList;
				classes.forEach(className => {
					if (className.startsWith('state_')) {
						states.add(className.replace('state_', ''));
					} else if (className.startsWith('color_')) {
						colors.add(className.replace('color_', ''));
					}
				});
			});
			this.createFilter('state', states, filterContainer, productsContainer);
			this.createFilter('color', colors, filterContainer, productsContainer);
		}

		createFilter(label, options, filterContainer, productsContainer) {
			const filterGroup = document.createElement('div');
			filterGroup.classList.add('filter-group', 'flex-col', 'gap-4');
			const filterLabel = document.createElement('h4');
			filterLabel.classList.add('mb-6');
			filterLabel.textContent = `Filtrer par ${label.toLowerCase()} :`;
			filterGroup.appendChild(filterLabel);
			const gridContainer = document.createElement('div');
			gridContainer.classList.add('grid', 'grid-cols-3', 'gap-4');
			options.forEach(option => {
				const checkboxWrapper = document.createElement('div');
				checkboxWrapper.classList.add('flex', 'items-center', 'justify-center');
				const checkbox = document.createElement('input');
				checkbox.type = 'checkbox';
				checkbox.id = `${label.toLowerCase()}-${option}`;
				checkbox.value = option;
				checkbox.classList.add('hidden', 'peer', `${label.toLowerCase()}-filter`);
				const labelElement = document.createElement('label');
				labelElement.setAttribute('for', checkbox.id);
				labelElement.classList.add('p-4', 'peer-checked:outline', 'peer-checked:outline-2', 'peer-checked:outline-blue-500', 'text-lg', 'w-full', 'text-center', 'bg-white', 'rounded', 'cursor-pointer');
				labelElement.textContent = option.charAt(0).toUpperCase() + option.slice(1);
				checkboxWrapper.appendChild(checkbox);
				checkboxWrapper.appendChild(labelElement);
				gridContainer.appendChild(checkboxWrapper);
			});
			filterGroup.appendChild(gridContainer);
			filterContainer.appendChild(filterGroup);
			const checkboxes = filterGroup.querySelectorAll('input[type="checkbox"]');
			checkboxes.forEach(checkbox => {
				checkbox.addEventListener('change', () => {
					console.log("Applying filters...");
					this.applyFilters(productsContainer);
				});
			});
		}

		applyFilters(productsContainer) {
			const selectedStates = this.getSelectedFilters('state');
			const selectedColors = this.getSelectedFilters('color');
			console.log("Selected States:", selectedStates);
			console.log("Selected Colors:", selectedColors);
			const products = productsContainer.querySelectorAll('.favorite-product');
			products.forEach(product => {
				const matchesState = selectedStates.length === 0 || selectedStates.some(state => product.classList.contains(`state_${state}`));
				const matchesColor = selectedColors.length === 0 || selectedColors.some(color => product.classList.contains(`color_${color}`));
				if (matchesState && matchesColor) {
					product.style.display = '';
				} else {
					product.style.display = 'none';
				}
			});
		}

		getSelectedFilters(filterType) {
			const checkboxes = document.querySelectorAll(`.${filterType}-filter:checked`);
			return Array.from(checkboxes).map(checkbox => checkbox.value);
		}

		groupAndSort(container) {
			const products = Array.from(container.children);
			function getClassValue(product, classPrefix) {
				const classList = Array.from(product.classList);
				const matchedClass = classList.find((className) => className.startsWith(classPrefix));
				return matchedClass ? matchedClass.split('_')[1] : 'other';
			}
			const typeOrder = ['cartridge', 'micr', 'head', 'drum', 'printer', 'other'];
			const stateOrder = ['original', 'compliant', 'unboxed', 'refurbished', 'compatible', 'other'];
			const groupedByType = products.reduce((groups, product) => {
				const type = getClassValue(product, 'type');
				if (!groups[type]) groups[type] = [];
				groups[type].push(product);
				return groups;
			}, {});
			const sortedTypes = Object.keys(groupedByType).sort((a, b) => {
				return typeOrder.indexOf(a) - typeOrder.indexOf(b);
			});
			sortedTypes.forEach((type) => {
				const groupedByState = groupedByType[type].reduce((stateGroups, product) => {
					const state = getClassValue(product, 'state');
					if (!stateGroups[state]) stateGroups[state] = [];
					stateGroups[state].push(product);
					return stateGroups;
				}, {});
				const sortedStates = Object.keys(groupedByState).sort((a, b) => {
					return stateOrder.indexOf(a) - stateOrder.indexOf(b);
				});
				sortedStates.forEach((state) => {
					const sortedByColor = groupedByState[state].sort((a, b) => {
						const colorA = getClassValue(a, 'color');
						const colorB = getClassValue(b, 'color');
						return compareColors(colorA, colorB);
					});
					const groupTitle = createGroupTitle(type, state);
					const groupContainer = document.createElement('div');
					groupContainer.classList.add('group-container', 'flex', 'flex-col', 'gap-4', `${type}-${state}`);
					const titleElement = document.createElement('h3');
					titleElement.classList.add('group-title', 'rounded', 'bg-white', 'uppercase', 'p-8');
					titleElement.textContent = groupTitle;
					groupContainer.appendChild(titleElement);
					sortedByColor.forEach((product) => groupContainer.appendChild(product));
					container.appendChild(groupContainer);
				});
			});
		}

		async fetchProductData(productId) {
			try {
				const response = await fetch(`/products/${productId}.json`);
				if (!response.ok) {
					console.error(`Erreur HTTP: ${response.statusText}`);
					return null;
				}
				const text = await response.text();
				if (!text) {
					console.error(`Réponse vide pour le produit ${productId}`);
					return null;
				}
				const data = JSON.parse(text);
				return data.product;
			} catch (error) {
				console.error(`Erreur lors de la récupération des données du produit ${productId}: `, error.message);
				return null;
			}
		}

	});
}
